const actions = {
  UPDATE_COUNT: "UPDATE_COUNT",

  updateCount: (data) => ({
    type: actions.UPDATE_COUNT,
    data,
  }),
};
export default actions;
